import { render, staticRenderFns } from "./UnitsSelectPaginated.vue?vue&type=template&id=1000dfb6&scoped=true"
import script from "./UnitsSelectPaginated.vue?vue&type=script&lang=js"
export * from "./UnitsSelectPaginated.vue?vue&type=script&lang=js"
import style0 from "./UnitsSelectPaginated.vue?vue&type=style&index=0&id=1000dfb6&prod&lang=scss&scoped=true"
import style1 from "./UnitsSelectPaginated.vue?vue&type=style&index=1&id=1000dfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000dfb6",
  null
  
)

export default component.exports